// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__22CMY","bigColWidth":"Table_bigColWidth__OwvhR","biggerColWidth":"Table_biggerColWidth__2o6P-","row":"Table_row__26z9x","col":"Table_col__2uPxJ"};